/**
 * @generated SignedSource<<3960ad9c0b664073445156b7b6359985>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScrapeAndSaveErrorType = "BUTTON_STYLE" | "COLOR_PALETTE" | "COMPONENT_MAPPINGS" | "FONT_FACES" | "LOGO" | "%future added value";
export type useScrapeAndSaveBrandStyleMutation$variables = {
  brandId: string;
};
export type useScrapeAndSaveBrandStyleMutation$data = {
  readonly scrapeAndSaveBrandStyle: {
    readonly brand: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"InternBrandStyleLogo_brand" | "InternBrandStylePalette_brand" | "InternBrandStyleTypography_brand">;
    };
    readonly errors: ReadonlyArray<{
      readonly message: string;
      readonly type: ScrapeAndSaveErrorType;
    }>;
  };
};
export type useScrapeAndSaveBrandStyleMutation = {
  response: useScrapeAndSaveBrandStyleMutation$data;
  variables: useScrapeAndSaveBrandStyleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "brandId",
    "variableName": "brandId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ScrapeAndSaveError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "background",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "foreground",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "outline",
  "storageKey": null
},
v8 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fontWeight",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fontFace",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useScrapeAndSaveBrandStyleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ScrapeAndSaveBrandStyleResult",
        "kind": "LinkedField",
        "name": "scrapeAndSaveBrandStyle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandType",
            "kind": "LinkedField",
            "name": "brand",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "InternBrandStylePalette_brand"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "InternBrandStyleLogo_brand"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "InternBrandStyleTypography_brand"
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useScrapeAndSaveBrandStyleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ScrapeAndSaveBrandStyleResult",
        "kind": "LinkedField",
        "name": "scrapeAndSaveBrandStyle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandType",
            "kind": "LinkedField",
            "name": "brand",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "InternBrandStyle",
                "kind": "LinkedField",
                "name": "internStyle",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternBrandStyleColorPalette",
                    "kind": "LinkedField",
                    "name": "colorPalettes",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accentBackground",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accentForeground",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "adPriority",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emailPriority",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BrandComponentColorsSuggestions",
                        "kind": "LinkedField",
                        "name": "componentColors",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BrandButtonColorsSuggestion",
                            "kind": "LinkedField",
                            "name": "button",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BrandShortcutsColorsSuggestion",
                            "kind": "LinkedField",
                            "name": "shortcuts",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "container",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BrandBadgeColorsSuggestion",
                            "kind": "LinkedField",
                            "name": "badge",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BrandNavBarColorsSuggestion",
                            "kind": "LinkedField",
                            "name": "navBar",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BrandBackgroundColorsSuggestion",
                            "kind": "LinkedField",
                            "name": "backgrounds",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "background1",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "background2",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BrandOnboardingColorsSuggestion",
                            "kind": "LinkedField",
                            "name": "onboarding",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternBrandStyleBasicColorPalette",
                    "kind": "LinkedField",
                    "name": "primaryButton",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "borderColor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternBrandStyleBasicColorPalette",
                    "kind": "LinkedField",
                    "name": "navbar",
                    "plural": false,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternBrandStyleSuggestedButtonStyle",
                    "kind": "LinkedField",
                    "name": "suggestedButtonStyle",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "borderRadius",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "borderWidth",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "textStyle",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternBrandStyleImage",
                    "kind": "LinkedField",
                    "name": "logos",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "src",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "html",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "width",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "height",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fonts",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternFontFamilyInfo",
                    "kind": "LinkedField",
                    "name": "fontFaces",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InternFontWeightInfo",
                        "kind": "LinkedField",
                        "name": "bold",
                        "plural": false,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InternFontWeightInfo",
                        "kind": "LinkedField",
                        "name": "regular",
                        "plural": false,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandAppConfigType",
                "kind": "LinkedField",
                "name": "appConfig",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryPaletteLight",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accent1PaletteLight",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accent2PaletteLight",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accent3PaletteLight",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "background1PaletteLight",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "background2PaletteLight",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BrandAppConfigBuildThemeType",
                    "kind": "LinkedField",
                    "name": "buildTheme",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "primaryButtonBackground",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "primaryButtonForeground",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "secondaryButtonOutline",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "primaryPillBackground",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "primaryPillForeground",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "secondaryPillOutline",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pillContainerBackground",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "badgeBackground",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "badgeForeground",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "navigationBackground",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "navigationForeground",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "onboardingBackground",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "onboardingForeground",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "buttonBorderThickness",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "buttonCornerRadius",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "buttonTextStyle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "logoUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BrandAppConfigBuildThemeFontType",
                        "kind": "LinkedField",
                        "name": "fonts",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          (v3/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5d8152207813cfbcd250e2de9c848b21",
    "id": null,
    "metadata": {},
    "name": "useScrapeAndSaveBrandStyleMutation",
    "operationKind": "mutation",
    "text": "mutation useScrapeAndSaveBrandStyleMutation(\n  $brandId: ID!\n) {\n  scrapeAndSaveBrandStyle(brandId: $brandId) {\n    brand {\n      id\n      ...InternBrandStylePalette_brand\n      ...InternBrandStyleLogo_brand\n      ...InternBrandStyleTypography_brand\n    }\n    errors {\n      message\n      type\n    }\n  }\n}\n\nfragment InternBrandStyleLogo_brand on BrandType {\n  id\n  internStyle {\n    logos {\n      type\n      src\n      html\n      width\n      height\n    }\n  }\n  appConfig {\n    id\n    buildTheme {\n      id\n      logoUrl\n    }\n  }\n}\n\nfragment InternBrandStylePalette_brand on BrandType {\n  id\n  internStyle {\n    colorPalettes {\n      background\n      foreground\n      accentBackground\n      accentForeground\n      adPriority\n      emailPriority\n      componentColors {\n        button {\n          background\n          foreground\n          outline\n        }\n        shortcuts {\n          background\n          foreground\n          outline\n          container\n        }\n        badge {\n          background\n          foreground\n        }\n        navBar {\n          background\n          foreground\n        }\n        backgrounds {\n          background1\n          background2\n        }\n        onboarding {\n          background\n          foreground\n        }\n      }\n    }\n    primaryButton {\n      background\n      foreground\n      borderColor\n    }\n    navbar {\n      background\n      foreground\n    }\n    suggestedButtonStyle {\n      borderRadius\n      borderWidth\n      textStyle\n    }\n  }\n  appConfig {\n    id\n    primaryPaletteLight\n    accent1PaletteLight\n    accent2PaletteLight\n    accent3PaletteLight\n    background1PaletteLight\n    background2PaletteLight\n    buildTheme {\n      id\n      primaryButtonBackground\n      primaryButtonForeground\n      secondaryButtonOutline\n      primaryPillBackground\n      primaryPillForeground\n      secondaryPillOutline\n      pillContainerBackground\n      badgeBackground\n      badgeForeground\n      navigationBackground\n      navigationForeground\n      onboardingBackground\n      onboardingForeground\n      buttonBorderThickness\n      buttonCornerRadius\n      buttonTextStyle\n    }\n  }\n}\n\nfragment InternBrandStyleTypography_brand on BrandType {\n  id\n  internStyle {\n    fonts\n    fontFaces {\n      name\n      bold {\n        url\n        fontWeight\n        fontFace\n      }\n      regular {\n        url\n        fontWeight\n        fontFace\n      }\n    }\n  }\n  appConfig {\n    id\n    buildTheme {\n      id\n      fonts {\n        name\n        type\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f33e7a67db134cc5c084ccc4e8f1b1ee";

export default node;
